import { useGetCityQuery } from '@/api/cities/get-city-query'
import { T } from '@/components/t'
import { cn } from '@/utils/styles/cn'

interface IRestaurantCitySeoDescriptionProps {
    citySlug: string
    className?: string
}

export const RestaurantCitySeoDescription = ({
    citySlug,
    className,
}: IRestaurantCitySeoDescriptionProps) => {
    const { data } = useGetCityQuery(citySlug)

    return (
        <T
            t={['restaurants.city.description', { cityName: data?.data.name ?? '' }]}
            className={cn('text-gray-500 text-center md:text-[14px] text-[12px]', className)}
        />
    )
}
